import type { AgentRuntimeSessionContextRef } from "@cord/shared"

export function normalizeSessionContextSummaryIntent(
  value: unknown,
): NonNullable<AgentRuntimeSessionContextRef["summaryIntent"]> {
  return value === "code_review" ? "code_review" : "handoff"
}

function getSessionContextRefKey(ref: AgentRuntimeSessionContextRef): string {
  return [
    "session",
    ref.sessionId,
    ref.conversationId ?? "",
    ref.origin ?? "context",
    normalizeSessionContextSummaryIntent(ref.summaryIntent),
  ].join(":")
}

export function dedupeSessionContextRefs(
  refs: AgentRuntimeSessionContextRef[],
): AgentRuntimeSessionContextRef[] {
  const byKey = new Map<string, AgentRuntimeSessionContextRef>()
  for (const ref of refs) {
    if (typeof ref.sessionId !== "string" || ref.sessionId.trim().length === 0) {
      continue
    }
    byKey.set(getSessionContextRefKey(ref), ref)
  }
  return Array.from(byKey.values())
}

export function sameSessionContextRefs(
  left: AgentRuntimeSessionContextRef[],
  right: AgentRuntimeSessionContextRef[],
): boolean {
  if (left === right) return true
  if (left.length !== right.length) return false

  for (let index = 0; index < left.length; index += 1) {
    const leftRef = left[index]
    const rightRef = right[index]
    if (
      leftRef.localId !== rightRef.localId
      || leftRef.referenceId !== rightRef.referenceId
      || leftRef.sessionId !== rightRef.sessionId
      || leftRef.conversationId !== rightRef.conversationId
      || leftRef.repositoryId !== rightRef.repositoryId
      || leftRef.title !== rightRef.title
      || leftRef.origin !== rightRef.origin
      || normalizeSessionContextSummaryIntent(leftRef.summaryIntent)
        !== normalizeSessionContextSummaryIntent(rightRef.summaryIntent)
    ) {
      return false
    }
  }

  return true
}

export function getSessionContextRefDisplayTitle(ref: AgentRuntimeSessionContextRef): string {
  const normalizedTitle = typeof ref.title === "string" ? ref.title.trim() : ""
  if (normalizedTitle.length > 0) return normalizedTitle
  return ref.sessionId.length > 8 ? ref.sessionId.slice(0, 8) : ref.sessionId
}

export function getSessionContextRefOriginLabel(origin: AgentRuntimeSessionContextRef["origin"]): string {
  if (origin === "continue" || origin === "continue_new_session") {
    return "Continue"
  }
  if (origin === "pr_linked_session") {
    return "Linked PR"
  }
  return "Context"
}
